// utils/routeCacheMiddleware.js
const routeCache = {
    store: {},
    lastActive: {},

    set(route, data) {
        const key = this._generateKey(route)
        this.store[key] = {
            data,
            timestamp: Date.now()
        }
        this.lastActive[key] = Date.now()
    },

    get(route) {
        const key = this._generateKey(route)
        const cache = this.store[key]
        if (cache && Date.now() - cache.timestamp < 1 * 60 * 1000) {
            this.lastActive[key] = Date.now()
            return cache.data
        }
        return null
    },
    remove(route) {
        const key = this._generateKey(route)
        if (this.store[key]) {
            delete this.store[key]
            delete this.lastActive[key]
        }
    },
    _generateKey(route) {
        return `${route.path}|${JSON.stringify(route.query)}`
    }
}

// 自动清理过期缓存
setInterval(() => {
    const now = Date.now()
    Object.keys(routeCache.store).forEach(key => {
        if (now - routeCache.lastActive[key] > 1* 60 * 1000) {
            delete routeCache.store[key]
            delete routeCache.lastActive[key]
        }
    })
},  60 * 1000)//每分钟检查一下是否有缓存的

export default routeCache



// WEBPACK FOOTER //
// ./src/utils/routeCacheMiddleware.js